import React, { FC, Fragment } from 'react';
import { Grid, CardContent, Divider } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { UserGroup } from 'types/app';
import { Separator } from 'components';
import { useClient, useContent } from 'hooks';
import { IPostRenderProps } from 'features/posting';
import {
  Commentary,
  Date,
  Engage,
  Groups,
  Reactions,
  Pin,
  Pinned,
  Share,
  ShareCount,
} from '../widgets';
import { getApprovedGroups, isShareable } from '../helpers';
import { Footer } from './index';

interface IProps extends WithStyles<typeof styles> {
  selectedGroup?: UserGroup;
  toggleState: IPostRenderProps['toggleState'];
}

const styles = (theme: Theme) =>
  createStyles({
    flexItem: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    content: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  });

const Meta: FC<IProps> = ({ classes, toggleState }) => {
  const content = useContent();
  const { disable_comments } = useClient();
  const { content_id, publish_at, reactions, share_count } = content;

  const showShare = isShareable(content);
  const approvedGroups = getApprovedGroups(content);
  const hasShares = !!share_count;

  return (
    <Fragment>
      <CardContent>
        <Engage />
        <Grid container alignItems="center">
          <Pin />
          <Groups groups={approvedGroups} />
          {!!approvedGroups.length && <Separator />}
          <Date contentId={content_id} publishAt={publish_at} />
        </Grid>
      </CardContent>
      <Divider />
      <CardContent className={classes.content}>
        <Grid container alignItems="center" justify="space-between" spacing={1}>
          <Grid item xs className={classes.flexItem}>
            <Reactions reactions={reactions} contentId={content_id} />
          </Grid>
          {hasShares && (
            <Grid item>
              <ShareCount />
            </Grid>
          )}
          {showShare && (
            <Grid item>
              <Share />
            </Grid>
          )}
        </Grid>
      </CardContent>
      <Divider />
      <Pinned toggleState={toggleState} />
      <Commentary toggleState={toggleState} />
      {!disable_comments && <Footer />}
    </Fragment>
  );
};

export default withStyles(styles)(Meta);
